/**
 * KAN-826: extra fields of a company from imports (read-only): name, value and
 * the "боту" mark. Nothing is rendered when there are none.
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ExtraFieldsList } from '@/components/clients/ExtraFieldsList';
import { toExtraFieldItems } from '@/lib/extraFields';

interface ClientCompanyExtraCardProps {
  extra: Record<string, unknown> | null | undefined;
}

export function ClientCompanyExtraCard({ extra }: ClientCompanyExtraCardProps) {
  const items = toExtraFieldItems(extra);
  if (items.length === 0) return null;
  return (
    <Card data-testid="client-company-extra">
      <CardHeader>
        <CardTitle>Дополнительно</CardTitle>
      </CardHeader>
      <CardContent>
        <ExtraFieldsList items={items} />
      </CardContent>
    </Card>
  );
}
